import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import SetPinCodeUI from './SetPinCodeUI.js'

class SetPinCodeSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: [],
      submitted: false,
    }
  }

  render() {
    return (
      <SetPinCodeUI
        context={this.props.context}
        messageList={this.state.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        // pin code
        pinCode={this.props.pinCode}
        onPinCodeChange={this.props.onPinCodeChange}
        pinCodeError={this.props.pinCodeError}
        setPinCodeError={this.props.setPinCodeError}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/pub/phonePinCode`,
      this.onSubmitCallback, {
      phoneNumber: this.props.phoneNumber,
      verificationCode: this.props.verifCode,
      pinCode: this.props.pinCode
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch (error.fieldName) {
          case 'phoneNumber':
            this.props.setPhoneNumberError(error.message)
            break;
          case 'verificationCode':
            this.props.setVerifCodeError(error.message)
            break;
          case 'pinCode':
            this.props.setPinCodeError(error.message)
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({
      successMsg: response.success,
      submitted: false
    })

    if (errorList.length === 0) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      this.props.context.onLogin(response.session)
    }
  }

  getMessages(context) {
    let arr = [
      'c_pin_code',
      'c_confirm'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pub_signup_w_ph_pin', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default SetPinCodeSF
